import React, { useContext } from 'react';
import tw from 'twin.macro';
import { TextLine } from './';
import { PreferenceContext } from '../context';

export const Small = ({ Type = 'small', children, text = children, ...restProps }) => {
  const {
    preference: { theme },
  } = useContext(PreferenceContext);
  const isLightTheme = theme === 'light';
  return (
    <TextLine
      text={text}
      Type={Type}
      small
      css={[tw`opacity-60`, isLightTheme && tw`opacity-100`]}
      {...restProps}
    />
  );
};
